import { Color } from 'csstype'
import { AcompanhamentoCondicaoSaudeTematicaEnum } from 'graphql/types.generated'
import React from 'react'

import { useAcompanhamentoCondicaoSaudeContext } from '../../context/AcompanhamentoCondicaoSaudeContext'
import {
  BuscaCidadaoQueryResultModel,
  CidadaoListagemDiabetesQueryModel,
  CidadaoListagemHipertensaoQueryModel,
  CidadaoListagemPessoaIdosaQueryModel,
  CidadaoListagemSaudeBucalQueryModel,
} from '../../model/lista-tematica/model-acompanhamentoCondicaoSaudeListaTematica'
import { CidadaoListagemDesenvolvimentoInfantilQueryModel } from '../../model/lista-tematica/model-desenvolvimentoInfantil'
import { CidadaoListagemGestantePuerperaQueryModel } from '../../model/lista-tematica/model-gestantePuerpera'
import { CidadaoListagemSaudeMulherQueryModel } from '../../model/lista-tematica/model-saudeMulher'
import { AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilAccordionSection } from './desenvolvimento-infantil/AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilAccordionSection'
import { AcompanhamentoCondicaoSaudeDiabetesAccordionPanel } from './diabetes/AcompanhamentoCondicaoSaudeDiabetesAccordionPanel'
import { AcompanhamentoCondicaoSaudeGestantePuerperaAccordionSection } from './gestante-puerpera/AcompanhamentoCondicaoSaudeGestantePuerperaAccordionSection'
import { AcompanhamentoCondicaoSaudeHipertensaoAccordionPanel } from './hipertensao/AcompanhamentoCondicaoSaudeHipertensaoAccordionPanel'
import { AcompanhamentoCondicaoSaudePessoaIdosaAccordionSection } from './pessoa-idosa/AcompanhamentoCondicaoSaudePessoaIdosaAccordionSection'
import { AcompanhamentoCondicaoSaudeBucalAccordionSection } from './saude-bucal/AcompanhamentoCondicaoSaudeBucalAccordionSection'
import { AcompanhamentoCondicaoSaudeMulherAccordionSection } from './saude-mulher/AcompanhamentoCondicaoSaudeMulherAccordionSection'

interface AcompanhamentoCondicaoSaudeAccordionSectionSelectorProps {
  row: BuscaCidadaoQueryResultModel
  iconColor: Color
}

export function AcompanhamentoCondicaoSaudeAccordionSectionSelector(
  props: AcompanhamentoCondicaoSaudeAccordionSectionSelectorProps
) {
  const { row, iconColor } = props
  const { tematica } = useAcompanhamentoCondicaoSaudeContext()

  const accordionSection = accordionSectionByTematica[tematica]
  return accordionSection?.(row, iconColor) ?? null
}

const accordionSectionByTematica: Partial<Record<
  AcompanhamentoCondicaoSaudeTematicaEnum,
  (row: AcompanhamentoCondicaoSaudeAccordionSectionSelectorProps['row'], iconColor: Color) => JSX.Element
>> = {
  [AcompanhamentoCondicaoSaudeTematicaEnum.GESTANTE_PUERPERA]: (row, iconColor) => (
    <AcompanhamentoCondicaoSaudeGestantePuerperaAccordionSection
      row={row as CidadaoListagemGestantePuerperaQueryModel}
      iconColor={iconColor}
    />
  ),
  [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_BUCAL]: (row, iconColor) => (
    <AcompanhamentoCondicaoSaudeBucalAccordionSection
      row={row as CidadaoListagemSaudeBucalQueryModel}
      iconColor={iconColor}
    />
  ),
  [AcompanhamentoCondicaoSaudeTematicaEnum.SAUDE_MULHER]: (row, iconColor) => (
    <AcompanhamentoCondicaoSaudeMulherAccordionSection
      row={row as CidadaoListagemSaudeMulherQueryModel}
      iconColor={iconColor}
    />
  ),
  [AcompanhamentoCondicaoSaudeTematicaEnum.DESENVOLVIMENTO_INFANTIL]: (row, iconColor) => (
    <AcompanhamentoCondicaoSaudeDesenvolvimentoInfantilAccordionSection
      row={row as CidadaoListagemDesenvolvimentoInfantilQueryModel}
      iconColor={iconColor}
    />
  ),
  [AcompanhamentoCondicaoSaudeTematicaEnum.DIABETES]: (row, iconColor) => (
    <AcompanhamentoCondicaoSaudeDiabetesAccordionPanel
      row={row as CidadaoListagemDiabetesQueryModel}
      iconColor={iconColor}
    />
  ),
  [AcompanhamentoCondicaoSaudeTematicaEnum.PESSOA_IDOSA]: (row, iconColor) => (
    <AcompanhamentoCondicaoSaudePessoaIdosaAccordionSection
      row={row as CidadaoListagemPessoaIdosaQueryModel}
      iconColor={iconColor}
    />
  ),
  [AcompanhamentoCondicaoSaudeTematicaEnum.HIPERTENSAO_ARTERIAL]: (row, iconColor) => (
    <AcompanhamentoCondicaoSaudeHipertensaoAccordionPanel
      row={row as CidadaoListagemHipertensaoQueryModel}
      iconColor={iconColor}
    />
  ),
}
